import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="uiheading">
                                            </div>
                                            <div className="uiheading">
                                            </div>
                                            <div className="uiheading">
                                            </div>
                                            <div className="uiheading">
                                            </div>
                                            <table width="100%" cellSpacing="0" cellPadding="0" border="0"
                                                   className="ilead_v_sport round roundone mutitable uiheading ilead_v_sport_center">
                                                <tbody>
                                                <tr>
                                                    <th width="20%" valign="top" align="left"
                                                        className="green_curve">Implementation
                                                    </th>
                                                    <th width="20%" valign="top" align="left"
                                                        className="green_curve1">Key points for review
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="lightgreen"><p>Get approval for the
                                                        changes from the top level; this makes it easier to
                                                        enforce throughout the organisation. </p></td>
                                                    <td width="20%" valign="top" align="left"
                                                        className="lightgreen"><p>Once plan is prepared, get
                                                        it in front of senior management team for approval,
                                                        even if you do not officially need it. It will make
                                                        life easier further down the organisation – did this
                                                        happen?</p></td>

                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen"><p>Successful process change
                                                        and improvement is driven by training, so make sure
                                                        time is allowed for communicating the changes and
                                                        arrange training where necessary.</p></td>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen"><p>Has a training plan been
                                                        put together and has it worked properly? Was the
                                                        improvement communicated around the organisation
                                                        (include explanation of why change is happening as
                                                        it might not have affected some people)?</p></td>

                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="lightgreen"><p>Documentation of the
                                                        process needs to be created/amended and needs to be
                                                        kept up to date where people can easily access
                                                        it.</p></td>
                                                    <td width="20%" valign="top" align="left"
                                                        className="lightgreen"><p>This should be done as a
                                                        matter of course, but is it?</p></td>

                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen  "><p>Is there a cost
                                                        implication for this process?</p></td>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen"><p>Not all improvements
                                                        involve costs, but if this does, who holds the
                                                        budget? Your work to date should have enough
                                                        evidence to justify any costs.</p></td>

                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="">
                                            </div>
                                            <table width="100%" cellSpacing="0" cellPadding="0" border="0"
                                                   className="ilead_v_sport rgtround">
                                                <tbody>
                                                <tr>
                                                    <th width="20%" valign="top" align="left"
                                                        className="green_curve green_curve1">Evaluation
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td width="20%" valign="top" align="left"
                                                        className="darkgreen uiheading">
                                                        <div className="paraspace"><p>This is
                                                            post-implementation evaluation. Depending on the
                                                            size of the process change, you need to
                                                            determine timeframes for evaluation; it could be
                                                            a week, a month or three months after the
                                                            improvement is introduced. It should not be left
                                                            any longer than three months. Any problems with
                                                            the process would be identified within that
                                                            timeframe and if further improvements are
                                                            needed, it is easier to introduce them before
                                                            everyone is too entrenched in the new
                                                            system.</p>
                                                            <p> You have already reviewed along the way, so
                                                                this evaluation is overall:</p></div>
                                                        <ul className="greenbullet-list uiheading">
                                                            <li><p>Did the process improve?</p></li>
                                                            <li><p>Was the training successful?</p></li>
                                                            <li><p>Have any further problems come to
                                                                light?</p></li>
                                                        </ul>
                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span
                                                className="heading">NEXT STEPS</span>
                                            </div>
                                            <p>When an organisation is accustomed to a culture of continuous
                                                improvement, changes are introduced more easily and people
                                                feel able to flag problems as they occur – and before they
                                                escalate.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcenter">
                                                <div className="uiheading">
                                                    <p>Are you thinking about a particular process at work
                                                        which hasn't changed or been thought about for
                                                        years? Notwithstanding our advice that there's
                                                        little point in change for change's sake, it's as
                                                        well to carry out an evaluation as we've described
                                                        here – and perhaps make a few small improvements at
                                                        most – rather than allow disaster to creep up while
                                                        your back's turned!</p>
                                                </div>
                                            </div>
                                            <p>Also, never forget the importance of the human element to
                                                change. In a study by van Dam et al.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>2</sup></a> employees
                                                were surveyed for their resistance to organisational change.
                                                The three factors that contributed most strongly to their
                                                relationship to change were information, participation and
                                                trust in management. So when implementing change, you may
                                                well want to try to keep people informed and involved as
                                                much as possible in order to get the buy-in you need from
                                                your co-workers to make meaningful change happen.</p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page8')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}